import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { catchError, of } from 'rxjs';

const SUPPORTED_LANGUAGES = new Set([
  'da-da',
  'de-de',
  'en',
  'en-gb',
  'es-ar',
  'es-es',
  'es-mx',
  'fi-fi',
  'fr-ca',
  'fr-fr',
  'it-it',
  'nl-nl',
  'no-no',
  'pl-pl',
  'sv-se',
]);

@Component({
  selector: 'payment-subscriber-agreement',
  templateUrl: './subscriber-agreement.component.html',
  styleUrls: ['./subscriber-agreement.component.scss'],
})
export class SubscriberAgreementComponent implements OnInit {
  agreementHtml: SafeHtml | null = null;

  private readonly basePath = './assets/staticFiles/subscriber-agreement_';
  private readonly defaultLanguage = 'en';

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    const requested =
      this.route.snapshot.queryParamMap.get('lang') || this.defaultLanguage;
    const language = SUPPORTED_LANGUAGES.has(requested)
      ? requested
      : this.defaultLanguage;
    this.loadAgreement(language);
  }

  private loadAgreement(language: string): void {
    this.fetch(language)
      .pipe(catchError(() => of(null)))
      .subscribe((html) => {
        if (html != null) {
          this.agreementHtml = this.sanitizer.bypassSecurityTrustHtml(html);
        }
      });
  }

  private fetch(language: string) {
    return this.http.get(`${this.basePath}${language}.html`, {
      responseType: 'text',
    });
  }
}
